import { capitalizeFirstLetter } from '@helpers/text';
import { Card, Space, Tooltip, Typography } from 'antd';
import { IDailyWeatherData } from 'interface/weather';
import moment from 'moment';
import { useMemo } from 'react';
import weathersIcon from '@assets/icons/weathers';

interface DailyWeatherCardProps {
  data: IDailyWeatherData;
}

const DailyWeatherCard: React.FC<DailyWeatherCardProps> = ({ data }) => {
  const iconSrc = useMemo(() => {
    return data.weather && weathersIcon[data.weather?.icon];
  }, [data.weather]);

  return (
    <Card className="weather-daily-card" bordered={false}>
      <Space direction="vertical" className="full-width items-center">
        <Typography.Title
          level={5}
          type="secondary"
          style={{ marginBottom: 0 }}
        >
          {moment(data.date_text).format('MM/DD')}
        </Typography.Title>
        <Tooltip title={capitalizeFirstLetter(data.weather?.description)}>
          <img
            className="weather-icon"
            src={iconSrc}
            alt={data.weather?.main}
          />
        </Tooltip>
      </Space>
    </Card>
  );
};

export default DailyWeatherCard;
